import { Label, SelectDropDown, Input } from "@callcenter/design-system"
import { useUnit } from "effector-react"
import { $themeService } from "@callcenter/effector-services"

import { createFontVariants } from "./user-theme-settings.constants"

export const UserThemeSettings = () => {
  const customThemeSettings = useUnit($themeService.$themeSettings)

  const actions = useUnit({
    themeSettingsChanged: $themeService.themeSettingsChanged
  })

  return (
    <>
      <SelectDropDown
        label={<Label label="Text" />}
        value={createFontVariants().find((font) => font.value === customThemeSettings?.font)}
        options={createFontVariants()}
        onSelect={(option) => {
          actions.themeSettingsChanged({ name: "font", value: option.value })
        }}
      />

      <Input.Base
        label={<Label label="Primary color" />}
        value={customThemeSettings?.primary ?? ""}
        placeholder="#RRGGBB"
        onChange={(value) => actions.themeSettingsChanged({ name: "primary", value })}
      />

      <Input.Base
        label={<Label label="Secondary color" />}
        value={customThemeSettings?.secondary ?? ""}
        placeholder="#RRGGBB"
        onChange={(value) => actions.themeSettingsChanged({ name: "secondary", value })}
      />

      <Input.Base
        label={<Label label="Link color" />}
        value={customThemeSettings?.link ?? ""}
        placeholder="#RRGGBB"
        onChange={(value) => actions.themeSettingsChanged({ name: "link", value })}
      />

      <Input.Base
        label={<Label label="Tertiary color" />}
        value={customThemeSettings?.tertiary ?? ""}
        placeholder="#RRGGBB"
        onChange={(value) => actions.themeSettingsChanged({ name: "tertiary", value })}
      />
    </>
  )
}
